import { adminRoles } from '@/constants';
import { checkAndRedirectForOrgAdminAccess } from '@/helpers';
import { hasAnyOrgRole } from '@/helpers/roles';
import { fetchOrganizations } from '@/pages/Organizations/orgUtils';
import { useAppStore } from '@/stores/app';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/organizations/')({
  beforeLoad: ({ context, location }) => {
    const store = useAppStore.getState();
    // Use selectedOrganization (runtime) if available, else fall back to selectedOrgStub (persisted)
    const selectedOrganization = store.selectedOrganization || store.selectedOrgStub;
    checkAndRedirectForOrgAdminAccess({
      context,
      location,
      selectedOrganization,
      adminRoles,
      redirect,
    });
  },
  loader: async ({ context }) => {
    // beforeLoad returns without throwing while auth is still PENDING, so the loader can still
    // run in that window — gate the actual fetch here too (issue #396, same as /instruments).
    const store = useAppStore.getState();
    const selectedOrganization = store.selectedOrganization || store.selectedOrgStub;
    if (
      context.authentication.status !== 'AUTHENTICATED' ||
      !selectedOrganization?.id ||
      !hasAnyOrgRole(context.authentication.user?.assumed_roles, selectedOrganization.id, adminRoles)
    ) {
      // `undefined`, never `[]`: OrganizationsPage seeds a non-array loader result as no
      // initialData at all. `[]` would seed a false "zero organizations" success that stays
      // fresh for ORGS_QUERY_STALE_TIME and blocks the refetch once the gate authorizes.
      return undefined;
    }

    const orgs = await fetchOrganizations();
    return Array.isArray(orgs) ? orgs : undefined;
  },
});
